/* eslint import/no-named-as-default:0 */
/* eslint react/jsx-filename-extension:0 */
import React from 'react';
import Popover from 'react-text-selection-popover';
import placeRightBelow from 'react-text-selection-popover/lib/placeRightBelow';
import ExternalResourceSuggestions from './ExternalResourceSuggestions';
import MentionSuggestions from './MentionSuggestions';
import InternalResourceSuggestions from './InternalResourceSuggestions';

const suggestions = {
    '@': MentionSuggestions,
    '+': InternalResourceSuggestions,
    '#': ExternalResourceSuggestions,
};

// Props
// @trigger
// @editorState
// @onChange
// @insertPageReference
// @addKeyBindingCallback
// @removeKeyBindingCallback
// @searchText

export default ({ trigger, ...props }) => {
    const Comp = suggestions[trigger];

    if (Comp == null) {
        return null;
    }

    return (
        <Popover placementStrategy={placeRightBelow} className="z5" isOpen>
            <Comp {...props} />
        </Popover>
    );
};
